import {
  ADD_CONTRAGENT_GROUP,
  DELETE_CONTRAGENT_GROUP,
  FETCH_CONTRAGENT_GROUP,
} from './actions/contragentGroup'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const contragentsGroupAPI = RepositoryFactory.get('contragentsGroup')

export default {
  state: {
    groups: [],
  },
  getters: {
    getContragentGroups: state => state.groups,
  },
  mutations: {
    [ADD_CONTRAGENT_GROUP]: (state, payload) =>
      (state.groups = [...state.groups, payload]),
    [FETCH_CONTRAGENT_GROUP]: (state, payload) => (state.groups = payload),
    [DELETE_CONTRAGENT_GROUP]: (state, payload) => {
      state.groups = state.groups.filter(group => group.id !== payload)
    },
  },
  actions: {
    async [ADD_CONTRAGENT_GROUP]({ commit }, payload) {
      await contragentsGroupAPI
        .add(payload)
        .then(response => commit(ADD_CONTRAGENT_GROUP, response.data))
    },
    async [FETCH_CONTRAGENT_GROUP]({ commit }) {
      await contragentsGroupAPI
        .getList()
        .then(response => commit(FETCH_CONTRAGENT_GROUP, response.data))
    },
    async [DELETE_CONTRAGENT_GROUP]({ commit }, payload) {
      await contragentsGroupAPI
        .delete(payload)
        .then(() => commit(DELETE_CONTRAGENT_GROUP, payload))
    },
  },
}
